export const runAfterDomLoad = (func: () => void): void => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', func);
    return;
  }

  func();
};
